const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiDataModel.CLIENTS)
const groupPrefixEmployee = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.CLIENTS)

export const apiClient = {
	createClient: async (obj: Partial<IClientModel>) => {
		const { data } = await apiCommon<IClient>(`${groupPrefix}`, {
			method: 'POST',
			body: clientToJSON(obj),
		})
		return clientFromJSON(data)
	},

	updateClient: async (clientUUID: string, obj: Partial<IClientModel>) => {
		if (obj.phoneNumber) obj.phone_number = obj.phoneNumber
		const { data } = await apiCommon<IClient>(`${groupPrefix}/${clientUUID}`, {
			method: 'PATCH',
			body: clientToJSON(obj),
		})
		return clientFromJSON(data)
	},

	fetchClients: async (
		activeFilter: string[] | undefined,
		cityFilter: string[] | undefined,
		search: string | undefined,
		page: number = 1,
		perPage: number = 25,
		id?: string[] | undefined,
		uuid?: string[] | undefined,
	) => {
		const { data, meta } = await apiCommon<IClient[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { active: activeFilter, city: cityFilter, search, id, uuid }),
		})
		return { data: data.map(d => clientFromJSON(d)), meta }
	},

	fetchClientDetails: async (clientUUID: string) => {
		const { data } = await apiCommon<IClient>(`${groupPrefix}/${clientUUID}`, { method: 'GET' })
		return clientFromJSON(data)
	},

	fetchClientsCities: async () => {
		const { data } = await apiCommon<string[]>(`${groupPrefix}/cities`, { method: 'GET' })
		return data
	},

	deleteClient: async (clientUUID: string) =>
		await apiCommon<IEmployee>(`${groupPrefixEmployee}/${clientUUID}`, { method: 'DELETE' }),

	resendClientEmailVerification: async (clientUUID: string) =>
		await apiCommon<IEmployee>(`auth/api/employee/clients/resend-email-verification/${clientUUID}`, {
			method: 'POST',
		}),
}
